module.exports = __webpack_public_path__ + "static/image/thumbnail.ver2_0_2.png?e33f895c";